import { useEffect, useState } from "react";
import { usePagination, useSortBy, useTable } from "react-table";
import PaginationComponent from "../../../Components/PaginationTableServer/PaginationTableServer";
import notfound from '../../../Assets/images/il-empty.svg';
import useLogin from "../../Autenticacion/Hooks/useLogin";
import { COLUMNAS_CARGA_INFORMES } from '../Utils/Columns';

const TablaCargaInformes = ({
	columns = COLUMNAS_CARGA_INFORMES,
	data = [],
	fetchData,
	pageCount: controlledPageCount,
	currentpage,
	pageSize: controlledPageSize,
	sortBy: controlledSortBy,
	setPagination,
	datosIndicador,
	esDescargar,
	setEsDescargar,
	handlerModal
}) => {
	const {
		getTableProps,
		getTableBodyProps,
		headerGroups,
		prepareRow,
		page,
		pageCount,
		gotoPage,
		state: { pageIndex, pageSize, sortBy }
	} = useTable(
		{
			columns,
			data,
			initialState: { pageIndex: currentpage, pageSize: controlledPageSize, sortBy: controlledSortBy },
			manualPagination: true,
			pageCount: controlledPageCount,
			autoResetPage: false,
			autoResetSortBy: false,
			manualSortBy: true
		},
		useSortBy,
		usePagination
	);
	const { usuario } = useLogin();
	const [valoresFormularioEnvio] = useState({
		paginacion: {
			numeroPagina: pageIndex,
			cantidadRegistros: pageSize,
			orderByAscending: false,
			ordenadoPor: ""
		},
		datosBusqueda: {
			exportacion: false,
			idUsuario: usuario.id,
			nivelCumplimientoId: datosIndicador.nivelCumplimiento
		}
	});

	useEffect(() => {
		fetchData({ formulario: valoresFormularioEnvio, pageIndex, sortBy });
		setPagination(values => ({
			...values,
			sortByCargaInformes: []
		}));
	}, [pageIndex, sortBy]);

	useEffect(() => {
		if (esDescargar) {
			fetchData({ formulario: valoresFormularioEnvio, pageIndex, sortBy, exportacion: true });
			setEsDescargar(false);
		}
	}, [esDescargar]);

	const mostrarModal = (e, row) => {
		e.preventDefault();
		if (handlerModal) {
			handlerModal(row);
		}
	}

	return (
		<>
			<div className="table-responsive">
				<table className="table" {...getTableProps()}>
					<thead>
						{headerGroups.map((headerGroup) => {
							const { key: hgKey, ...hgProps } = headerGroup.getHeaderGroupProps();
							return (
							<tr key={hgKey} {...hgProps}>
								{headerGroup.headers.map((column) => {
									const colHeaderProps = data.length > 0
										? column.getHeaderProps(column.getSortByToggleProps(), { className: column.className })
										: column.getHeaderProps({ className: column.className });
									const { key: colKey, ...colProps } = colHeaderProps;
									return data.length > 0 ? (
										<th key={colKey} {...colProps}>
											<span className="d-flex align-items-center gap-1">
												{column.render('Header')}
												{column.isSorted && data.length > 0 ?
													(column.isSortedDesc ?
														<i className="ico-chevron-down"></i>
														:
														<i className="ico-chevron-up"></i>
													)
													:
													<i className="ico-sort fs-7"></i>
												}
											</span>
										</th>
									) : (
										<th key={colKey} {...colProps}>
											<span className="d-flex align-items-center gap-1">
												{column.render('Header')}
											</span>
										</th>
									)
								})}
								<th className="text-center">Detalle</th>
							</tr>
							)
						})}
					</thead>
					<tbody {...getTableBodyProps()}>
						{page.length > 0 && page.map((row) => {
							prepareRow(row);
							const { key: rowKey, ...rowProps } = row.getRowProps();
							return (
								<tr key={rowKey} {...rowProps}>
									{row.cells.map((cell) => {
										const { key: cellKey, ...cellProps } = cell.getCellProps({
											className: cell.column.className
										});
										return (
											<td key={cellKey} {...cellProps}>
												{cell.render('Cell')}
											</td>
										);
									})}
									<td className="text-center">
										<button className="link text-pewter-blue fs-4" onClick={(e) => mostrarModal(e, row.original)}>
											<i className="ico-search"></i>
										</button>
									</td>
								</tr>
							);
						}) || <tr>
								<td colSpan={headerGroups[0].headers.length + 1}>
									<div className="d-flex justify-content-center align-items-center flex-column gap-2 py-5">
										<img className="mb-3" src={notfound} alt="" />
										<p className="mb-0 text-primary">No se encuentran resultados de tu b&uacute;squeda.</p>
									</div>
								</td>
							</tr>
						}
					</tbody>
				</table>
			</div>
			{data.length > 0 &&
				<PaginationComponent
					pagesCountServer={pageCount}
					currentPage={pageIndex}
					setCurrentPage={gotoPage}
					alwaysShown={true}
					setPagination={setPagination}
				/>
			}
		</>
	);
};

export default TablaCargaInformes;
